export enum AuditSortFieldEnum {
  DATE = 'date',
}
